import React from 'react'
import { Table, Input, Icon, Form } from 'antd'
import { createUuid } from '@utils/NHCore'
import NHSelect from '@components/common/NHSelect'
import NHFormItem from "@components/common/NHFormItem";
import NHFetch from '@utils/NHFetch'
import { FormRules } from '@utils/RegExp'
import '../index.css'

class JtcyInitForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      fmList: [
        { label: '父亲', value: '父亲' },
        { label: '母亲', value: '母亲' },
      ], //父母数据加载
      jtcyList: [], //家庭成员数据加载
      flag: false,
      showJtcyData: [],
    }
  }

  componentDidMount() {

    NHFetch(
      'front/zhxg-unauth/yxwz/proData/selectDataList?&sign=DMK_YXXT_JTCYGX',
      'GET'
    ).then(res => {
      if (res && res.data) {
        let jtcyList = []
        for (let obj of res.data) {
          jtcyList.push({ label: obj.LABEL, value: obj.LABEL })
        }
        this.setState({ jtcyList: jtcyList })
      }
    })
    this.setState({
      showJtcyData: this.props.jtcyInitData ? [...this.props.jtcyInitData] : []
    })
  }

  // 单亲家庭添加一项, 可编辑，只能选父母；孤儿学生不用添加；其他添加父母两项，不可编辑
  initByGrqk = (grqk) => {
    if (!grqk) return;

    // 1. 先过滤掉所有父母数据（01和02）
    const filteredData = this.state.showJtcyData.filter(
      item => !['父亲', '母亲'].includes(item.GX)
    );

    const father = this.state.showJtcyData.filter(
        item => ['父亲'].includes(item.GX)
    );

    const mother = this.state.showJtcyData.filter(
        item => ['母亲'].includes(item.GX)
    );

    // 2. 根据grqk参数添加新的父母数据
    let presetItems = [];

    console.log('grqk >>>>>>>>>>', grqk);
    console.log('father >>>>>>>>>>', father);
    console.log('mother >>>>>>>>>>', mother);
    console.log('this.state.showJtcyData >>>>>>>>>>', this.state.showJtcyData);

    if (grqk === '1') {
      if (father && father.length > 0) {
        presetItems.push(father[0])
      } else if (mother && mother.length > 0) {
        presetItems.push(mother[0])
      } else {
        presetItems.push({
          key: createUuid(),
          GX: "父亲",  // 父亲
          XM_1: '',
          LXFS: '',
          ZZZT: '',
          GZDW: '',
          ZW: '',
          gxEditable: true  // 允许编辑关系
        });
      }

    }
    else if (grqk === '0') {
      if (father && father.length > 0) {
        presetItems.push(father[0])
      } else {
        presetItems.push({
          key: createUuid(),
          GX: "父亲",  // 父亲
          XM_1: '',
          LXFS: '',
          ZZZT: '',
          GZDW: '',
          ZW: '',
          gxEditable: false  // 禁止编辑关系
        });
      }
      if (mother && mother.length > 0) {
        presetItems.push(mother[0]);
      } else {
        presetItems.push(
            {
              key: createUuid(),
              GX: "母亲",  // 母亲
              XM_1: '',
              LXFS: '',
              ZZZT: '',
              GZDW: '',
              ZW: '',
              gxEditable: false
            }
        );
      }
    }

    // 3. 合并数据（新的父母数据在前，其他数据在后）
    this.setState({
      showJtcyData: [...presetItems, ...filteredData]
    });
  }

  // 家庭成员 添加
  onjtcyAdd = (item = {
    GX: "",  // 母亲
    XM_1: '',
    LXFS: '',
    ZZZT: '',
    GZDW: '',
    ZW: '',
    operation: '',
  }) => {
    let { showJtcyData } = this.state
    let key = createUuid()
    showJtcyData.push({
      key: key,
      ...item
    })

    this.setState({ showJtcyData })
  }
  // 家庭成员 关闭添加
  onjtcyClose = (e, index) => {
    e.preventDefault();
    const { showJtcyData } = this.state;

    // 2. 删除数据项
    const newData = showJtcyData.filter((_, i) => i !== index);
    this.setState({ showJtcyData: newData });
  }

  handleChange = (value, index, key) => {
    let { showJtcyData } = this.state
    showJtcyData[index][key] = value
    this.setState({ showJtcyData })
  }

  // 添加验证方法
  validateUniquePhone = (rule, value, callback) => {
    const { form } = this.props;
    const values = this.props.form.getFieldsValue()
    const familyArray = values.familyList ? Object.values(values.familyList) : [];

    // 检查联系方式(LXFS)是否有重复
    const phoneSet = new Set();
    let hasDuplicate = false;

    familyArray.forEach(item => {
      if (item.LXFS) {
        if (phoneSet.has(item.LXFS)) {
          hasDuplicate = true;
        } else {
          phoneSet.add(item.LXFS);
        }
      }
    });

    if (hasDuplicate) {
      callback('联系方式不能重复');
    } else {
      callback();
    }
  }

  render() {
    const { jtcyList, showJtcyData, fmList } = this.state
    const { form, isRequired, editable } = this.props

    const jtcyColumns = [
      {
        title: <div><span style={{ color: 'red' }}>*</span>关系</div>,
        key: 'GX',
        dataIndex: 'GX',
        width: 120,
        render: (text, record, index) => {
          const isParentItem = typeof record.gxEditable !== 'undefined';
          const optionsSource = isParentItem ? fmList : jtcyList;
          if (!editable) {
            return text
          }

          return (
            <NHFormItem
              id={`familyList[${record.key}].GX`}
              form={form}
              required={true}
              formItemLayout={{
                wrapperCol: { span: 24 }
              }}
              initialValue={text}
            >
              <NHSelect
                style={{ width: 100 }}
                dataSource={optionsSource}
                // value={text}
                onChange={value => this.handleChange(value, index, 'GX')}
                disabled={!editable || (isParentItem && !record.gxEditable)}
              />
            </NHFormItem>
          );
        },
      },
      {
        title: <div><span style={{ color: 'red' }}>*</span>姓名</div>,
        dataIndex: 'XM_1',
        width: 120,
        render: (text, record, index) => {
          return editable ? (
            <NHFormItem
              id={`familyList[${record.key}].XM_1`}
              form={form}
              required={true}
              formItemLayout={{
                wrapperCol: { span: 24 }
              }}
              initialValue={text}
            >
              <Input
                // value={text}
                onChange={e => {
                  this.handleChange(e.target.value, index, 'XM_1')
                }}
                style={{ width: 100 }}
                placeholder='请填写姓名'
              />
            </NHFormItem>

          ) : (
            text
          )
        },
      },
      {
        title: <div><span style={{ color: 'red' }}>*</span>联系方式</div>,
        dataIndex: 'LXFS',
        width: 140,
        render: (text, record, index) => {
          return editable ? (
            <NHFormItem
              id={`familyList[${record.key}].LXFS`}
              form={form}
              required={true}
              formItemLayout={{
                wrapperCol: { span: 24 }
              }}
              initialValue={text}
              pattern={FormRules.MOBILE_PHONE_NUMBER}
              validator={this.validateUniquePhone}
            >
              <Input
                // value={text}
                maxLength={11}
                onChange={e => {
                  this.handleChange(e.target.value, index, 'LXFS')
                }}
                style={{ width: 110 }}
                placeholder='请填写电话'
              />
            </NHFormItem>
          ) : (
            text
          )
        },
      },
      {
        title: <div><span style={{ color: 'red' }}>*</span>在职状态</div>,
        dataIndex: 'ZZZT',
        width: 120,
        render: (text, record, index) => {
          return editable ? (
            <NHFormItem
              id={`familyList[${record.key}].ZZZT`}
              form={form}
              required={true}
              formItemLayout={{
                wrapperCol: { span: 24 }
              }}
              initialValue={text}
            >
              <NHSelect
                style={{ width: 100 }}
                dataSource={[
                  { value: '在职', label: '在职' },
                  { value: '退休', label: '退休' },
                  { value: '其他', label: '其他' },
                ]}
                // value={text}
                onChange={value => this.handleChange(value, index, 'ZZZT')}
              />
            </NHFormItem>
          ) : (
            text
          )
        },
      },
      {
        title: <div><span style={{ color: 'red' }}>*</span>工作单位</div>,
        dataIndex: 'GZDW',
        width: 170,
        render: (text, record, index) => {
          return editable ? (
            <NHFormItem
              id={`familyList[${record.key}].GZDW`}
              form={form}
              required={true}
              formItemLayout={{
                wrapperCol: { span: 24 }
              }}
              initialValue={text}
            >
              <Input
                // value={text}
                onChange={e => {
                  this.handleChange(e.target.value, index, 'GZDW')
                }}
                style={{ width: 140 }}
                placeholder='请填写工作单位'
              />
            </NHFormItem>
          ) : (
            text
          )
        },
      },
      {
        title: <div><span style={{ color: 'red' }}>*</span>职务</div>,
        dataIndex: 'ZW',
        width: 170,
        render: (text, record, index) => {
          return editable ? (
            <NHFormItem
              id={`familyList[${record.key}].ZW`}
              form={form}
              required={true}
              formItemLayout={{
                wrapperCol: { span: 24 }
              }}
              initialValue={text}
            >
              <Input
                onChange={e => {
                  this.handleChange(e.target.value, index, 'ZW')
                }}
                style={{ width: 140 }}
                placeholder='请填写职务'
              />
            </NHFormItem>

          ) : (
            text
          )
        },
      },
      {
        title: '删除',
        dataIndex: 'operation',
        width: 80,
        render: (text, record, index) => {
          const isParentItem = typeof record.gxEditable !== 'undefined';
          if (isParentItem) return null

          // if (jtcy) {
          //   return (
          //     <div className='editable-row-operations'>
          //       <a href='#' onClick={e => this.onjtcyClose(e, index)}>
          //         <Icon type='close' style={{ color: 'red' }} />
          //       </a>
          //     </div>
          //   )
          // }
          return (
            <a href='#' onClick={e => this.onjtcyClose(e, index)}>
              <Icon type='delete' style={{ color: 'red' }} />
            </a>
          )
        },
      },
    ]
    if (!editable) {
      jtcyColumns.pop()
    }
    return (
      <div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ height: '18px', width: '3px', borderRadius: '20px', background: '#066DBF' }}></div>
          <div styleName="title_top_name" style={{ borderLeft: 0 }}>
            <span><span style={{ display: isRequired ? '' : 'none', color: 'red' }}>*</span>家庭成员信息</span>
          </div>
        </div>

        <Form>
          <div className='p-sw family-information-content'>
            <Table
              bordered
              size='middle'
              pagination={false}
              dataSource={showJtcyData}
              columns={jtcyColumns}
              scroll={{ x: 1000 }}
            />
            {editable && (
              <div
                className='mt-10'
                styleName='btn_add'
                onClick={this.onjtcyAdd}
              >
                添加家庭成员
              </div>
            )}
          </div>
        </Form>
      </div>
    )
  }
}

export default JtcyInitForm
